var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bpm-viewer"},[_c('viewer',{attrs:{"images":_vm.imgList}},[_vm._t("default",_vm._l((_vm.imgList),function(src){return _c('img',{key:src,staticClass:"viewer-img",attrs:{"src":src}})}),{"list":_vm.imgList})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }